import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore } from 'redux-persist'
import logger from 'redux-logger'
import rootReducer from './reducers'

let reduxStore
function configureStore(initialState = {}) {
  if (reduxStore) {
    return
  }
  const middlewares = [logger]
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middlewares)),
  )

  const persistor = persistStore(store)

  reduxStore = { store, persistor }
  return reduxStore
}

export default configureStore
